<template>
    <div class="container">
        <div class="introduction">
            您可以在本页下载“联想打印”APP，以及联想云打印微信小程序链接
        </div>
        <div>
            <van-grid :column-num="1" icon-size="200px">	 
            <van-grid-item :icon ="lxdyandirod" text = "联想打印安卓" >
                </van-grid-item>
                <van-grid-item :icon = "lxdyios" text = "联想打印IOS" >
                </van-grid-item>
                <van-grid-item :icon = "wxmini" text = "微信小程序" >
                </van-grid-item>
            </van-grid> 
        </div>
    </div>
</template>
<script>
	import { Dialog } from 'vant';
	export default {
	  name: 'apps',
	  components: {},
	    data(){
		 return {
			lxdyandirod:'https://www.lenovoimage.com/images/lenovoprint_and.png',
			lxdyios:'https://www.lenovoimage.com/images/lenovoprint_ios.png',
            wxmini: require('../../assets/wxmini.jpg')
		 } 
		}
	}
		 
</script>
<style>
   .container {
    margin: 0 auto;
   }
   .introduction{
    font-size: 14px;
    margin-top: 50px;
   }
</style>